import { t } from "@lingui/macro";
import graphql from "babel-plugin-relay/macro";
import { useFragment } from "react-relay";

import { HStack, Text } from "@whoosh/design-system/src/components/primitive";

import { BookingOwner_Booking$key } from "./__generated__/BookingOwner_Booking.graphql";

type Props = {
  bookingOwnerRef: BookingOwner_Booking$key | null;
};

export const BookingOwner = ({ bookingOwnerRef }: Props) => {
  const bookingData = useFragment(BookingOwnerFragmentString, bookingOwnerRef);
  if (
    !bookingData ||
    !bookingData.ownerClient ||
    !bookingData.ownerClient.fullName
  )
    return null;

  return (
    <HStack
      flex={1}
      justifyContent="center"
      alignItems="center"
      gap={1}
      marginTop={3}
    >
      <Text
        color="text-secondary"
        variant="mainBaseMedium"
      >{t`Booking Owner:`}</Text>
      <Text color="text-secondary" variant="mainBaseSemiBold">
        {bookingData.ownerClient.fullName}
      </Text>
    </HStack>
  );
};

const BookingOwnerFragmentString = graphql`
  fragment BookingOwner_Booking on Booking {
    ownerClient {
      ... on Customer {
        id
        fullName
      }
      ... on Member {
        id
        fullName
      }
    }
  }
`;
